jQuery(document).ready(() => {
	const openRsvpBtn = $(".open-rsvp-form");
	const popupWrap = $(".rsvp-popup-wrap");
	const popupForm = $(".rsvp-form");
	const popupOverlay = $(".rsvp-popup-overlay");
	const rsvpSelector = $('.rsvp-selector');

	//Multiple RSVP options
	rsvpSelector.click(function(e) {
		e.preventDefault();

		rsvpSelector.removeClass('active');
		$(this).addClass('active');

		const ticket = $(this).attr('data-select-id');
		const meta = $('.tribe-event-tickets-plus-meta');
		const metaInput = meta.find('input');
		const metaInputWrapper = meta.find('.tribe-tickets-meta');
		const currentMeta = $('.tribe-event-tickets-plus-meta[data-ticket-id="'+ticket+'"]');
		const currentMetaInput = currentMeta.find('input');
		const currentMetaInputWrapper = currentMeta.find('.tribe-tickets-meta');
		const quantity = $('.tribe-ticket.quantity');
		const currentQuantity = $('.tribe-ticket.quantity[data-product-id="'+ticket+'"]');
		const quantityInput = $('.tribe-tickets-quantity');
		const currentQuantityInput = $('.tribe-tickets-quantity[name="quantity_'+ticket+'"]');

		metaInput.each(function() {
			const $this = $(this);
			const attr = $this.attr('required');
			if (typeof attr !== typeof undefined && attr !== false) {
				$this.addClass('required').removeAttr('required');
			}
		});
		metaInputWrapper.each(function() {
			const $this = $(this);
			$this.removeClass('tribe-tickets-meta-required')
		});
		currentMetaInput.removeClass('required').attr('required', 'required');
		currentMetaInputWrapper.addClass('tribe-tickets-meta-required');
		meta.hide();
		currentMeta.show();
		quantity.hide();
		currentQuantity.show();
		quantityInput.removeAttr('readonly').attr('value', 0).attr('readonly', 'readonly');
		currentQuantityInput.removeAttr('readonly').attr('value', 1).attr('readonly', 'readonly');
	});

	// Open-Close Popup Function
	$(openRsvpBtn).click(function() {
		popupOverlay.fadeIn(300, function() {
			popupWrap.animate({ opacity: "1" }, 400);
		});
		$("body").css("overflow-y", "hidden");

		//Select first of RSVP options
		rsvpSelector.first().click();

		//Cleanup min-height
		const form = $('#tribe-tickets');
		const common = $('.tribe-common');
		setTimeout(function() {
			form.css('min-height', 0);
			common.css('min-height', 0);
		}, 300);

		return false;
	});

	$(document).click(function(e) {
		if ( !$(e.target).is(popupForm) && $(e.target).is(popupOverlay) ) {
			popupWrap.animate({ opacity: "0" }, 400, function() {
				popupOverlay.fadeOut(300);
			});
			$("body").css("overflow-y", "scroll");
		}
	});
});



// WEBPACK FOOTER //
// ./scripts/modules/rsvp.js